module.exports = __webpack_public_path__ + "img/page-33.85cb6b07.jpg";